var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-flix-button',{attrs:{"variant":"text-icon","callback":_vm.setOpen}},[_vm._v(_vm._s(_vm.label))]),(_vm.open)?_c('b-flix-p',{staticClass:"openMore"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }